import { getCarsSeen, getCarsSeenForCurrentCar } from '../../selectors';

export const carsSeenSelectors = {
  getCarsSeen,
  getCarsSeenForCurrentCar,
};
